<template>
	<div class="email-message-field c-field c-field-level">
		<label v-if="label" class="label">{{ label }}</label>
		<div class="c-editor">
			<RichText
				class="c-editor"
				:content="processedValue"
				:tokens="tokensList"
				:default-offset="5"
				:placeholder="placeholder"
				custom-class="email-message-rich-text"
				:menu-placement="menuPlacement"
				output-context="email"
				is-dialog
				is-modal-context
				append-to-body
				suppress-token-deletion
				@update="handleEmailMessageUpdate"
				@input="handleEmailMessageInput"
			/>
		</div>
	</div>
</template>

<script lang='ts'>
	import { defineComponent } from 'vue';
	import RichText from 'src/components/form-controls/RichText/RichText.vue';
	import { getTokenizedValue, removeDeletedTokens, replaceParagraphsWithSpaces } from './tokenUtils';

	export default defineComponent({
		name: 'EmailMessage',
		components: {
			RichText
		},
		props: {
			label: {
				type: String,
				default: null
			},
			value: {
				type: String,
				default: null
			},
			tokensList: {
				type: Array,
				default: () => []
			},
			placeholder: {
				type: String,
				default: 'Message'
			},
			menuPlacement: {
				type: String,
				default: 'top-start'
			}
		},
		data() {
			return {
				processedValue: getTokenizedValue(this.value, this.tokensList),
				changedValue: getTokenizedValue(this.value, this.tokensList)
			};
		},
		watch: {
			value() {
				this.changedValue = getTokenizedValue(this.value, this.tokensList);
				if (this.changedValue !== this.value || (this.processedValue !== this.changedValue && this.processedValue === ''))
					this.processedValue = this.changedValue;
			},
			tokensList() {
				const changedValue = removeDeletedTokens(this.value, this.tokensList);
				if (changedValue !== this.processedValue) { // if there is a change, update the value
					this.handleEmailMessageUpdate(this.changedValue);
				}
			}
		},
		methods: {
			handleEmailMessageUpdate(val) {
				this.$emit('change', replaceParagraphsWithSpaces(val));
			},
			handleEmailMessageInput(val) {
				this.$emit('input', val);
			}
		}
	});

</script>